export default {
  "name": "Drowning Language I",
  "slug": "drowning-language-i",
  "path": "/drowning-language-i",
  "componentName" : "DrowningLanguageI",
  "category": "Projects",
  "parent": "Drowning Language",
  "isPublic": true
}